import {
  CKBox,
  CKLayoutGrid,
  CKLayoutHorizontal,
  CKProgressBar,
  CKSkeleton,
} from 'clearkit';
import { useMemo } from 'react';

const matchRateCount = 4;
const loadingPlaceholder = Array.from(Array(matchRateCount)).map(
  (_, index) => ({
    label: `loading ${index}`,
    value: 0,
  }),
);

export type MatchRateAttributeType = {
  label: string;
  value: number;
};

type MatchRateAttributesProps = {
  attributes: MatchRateAttributeType[];
  isLoading?: boolean;
};

export const MatchRateAttributes = ({
  attributes,
  isLoading,
}: MatchRateAttributesProps) => {
  const displayAttributes = useMemo(() => {
    if (isLoading) return loadingPlaceholder;
    if (!attributes) return [];

    return attributes.sort((a, b) => b.value - a.value).slice(0, 4);
  }, [isLoading]);

  return (
    <div className="relative pr-6 min-h-[10.5rem]">
      {displayAttributes.length ? (
        displayAttributes.map((attribute) => (
          <CKLayoutGrid
            gap="0"
            gridTemplateColumns="8rem 1fr"
            key={attribute.label}
          >
            <div className="text-sm border-r border-gray-200 py-2.5">
              <CKSkeleton
                className="h-5 w-[14ch]"
                isLoading={!!isLoading}
                label="loading"
              >
                <p className="h-5">{attribute.label}</p>
              </CKSkeleton>
            </div>
            <div className="self-center pr-4">
              <CKProgressBar
                borderRadius="0 .25rem .25rem 0"
                className="h-2"
                hasBackground={false}
                max={100}
                value={Math.round(attribute.value * 100)}
                variant="x"
              >
                {attribute.value && !isLoading ? (
                  <CKProgressBar.LabelValue className="relative text-sm -top-1" />
                ) : null}
              </CKProgressBar>
            </div>
          </CKLayoutGrid>
        ))
      ) : (
        <CKLayoutHorizontal
          className="absolute inset-0 w-full h-full"
          justifyContent="center"
        >
          <CKBox className="p-4">No match rate attributes to display</CKBox>
        </CKLayoutHorizontal>
      )}
    </div>
  );
};
